import React, { Component, Fragment } from 'react'
import { Select, Divider } from 'antd'
import pluralize from 'pluralize'
import styled from '@emotion/styled'
import { AddNewItem } from 'components'

pluralize.addSingularRule(/cookies$/i, 'cookie')

const { singular } = pluralize
const { Option } = Select

const StyledCreateOrSelect = styled.div({
	marginBottom: 30
})

const StyledSelect = styled(Select)({
	'.ant-select-selection': {
		borderRadius: 4
	}
})

const AddNew = styled.div({
	padding: '10px 0',
	textAlign: 'center'
})

const FirstItemTitle = styled.h3({
	textTransform: 'capitalize'
})

class CreateSelect extends Component {

	render() {
		const { items, disabledItems, dataTypeText, onSelect, onAddNewItem, disableNewItem, hideAddButton, ...restProps } = this.props
		return (
			<StyledSelect
				labelInValue
				disabled={disableNewItem}
				placeholder={`Select Existing ${dataTypeText.charAt(0).toUpperCase() + dataTypeText.slice(1)}`}
				onSelect={onSelect}
				dropdownRender={menu => (
					<Fragment>
						{menu}
						<Divider style={{ margin: 0 }} />
						{!disableNewItem && !hideAddButton && (
							<AddNew>
								<AddNewItem icon="plus" onMouseDown={e => e.preventDefault()} onClick={onAddNewItem}>
									ADD NEW
								</AddNewItem>
							</AddNew>
						)}
					</Fragment>
				)}
				{...restProps}
			>
				{items.map(item => {
					let isDisabled = disabledItems.find(d => d.id === item.id)
					return (
						<Option style={{ borderTop: '1px solid #EAEFF4' }} key={item.id} value={item.id} disabled={!!isDisabled}>
							{item.name}
						</Option>
					)
				})}
			</StyledSelect>
		)
	}
}


const CreateOrSelect = props => {
	const { list, selectedItems, dataTypeText, onSelect, onAddNewItem, allowMultiple = true } = props
	let singularType = singular(dataTypeText)
	let disabledItems = selectedItems || []
	let disableNewItem = !allowMultiple && disabledItems.length > 0;
	let allowAddNewButton =  allowMultiple || selectedItems && !selectedItems.length 
	let hasGlobals = list && !!list.length;

	return (
		<StyledCreateOrSelect>
			{allowAddNewButton && hasGlobals ? (
				<>
					<CreateSelect
						style={{ width: 220 }}
						items={list}
						disabledItems={selectedItems}
						dataTypeText={singularType}
						onSelect={onSelect}
						onAddNewItem={onAddNewItem}
						disableNewItem={disableNewItem}
						hideAddButton={true}
					/>
					<AddNewItem onClick={onAddNewItem}>+ ADD NEW {singularType.toUpperCase()}</AddNewItem>
				</>
			) : !!selectedItems.length && allowMultiple ? (
				<AddNewItem onClick={onAddNewItem}>+ ADD NEW {singularType.toUpperCase()}</AddNewItem>
			) : (
				!disableNewItem && (
					<FirstItemTitle>
						No Existing {dataTypeText}. Create Your First {singularType}
					</FirstItemTitle>
				)
			)}
		</StyledCreateOrSelect>
	)
}
export default CreateOrSelect
